import { routerMutex } from "@bebit/store";
import { DateRange } from "@bebit/types";
import { computed, ComputedRef } from "vue";
import { useRouter, useRoute } from "vue-router";
import { usePresetUrlParams } from "@host/composables/url-params/usePresetUrlParams";
import {
  getDateRangeOfPeriodChoice,
  isIn30DaysRange,
  isOlderOrEqualTo2DaysAgo,
  isWithin2Years,
} from "@host/utils/date-picker";
import { convertPeriodFromRouteQueryToPeriod, convertPeriodToRouteQueryFormat } from "@host/utils/report-period";

export function usePeriodUrlParams() {
  const route = useRoute();
  const router = useRouter();

  const { presetFromUrl } = usePresetUrlParams();

  const periodFromUrl: ComputedRef<DateRange | undefined> = computed(() => {
    if (presetFromUrl.value) return getDateRangeOfPeriodChoice(presetFromUrl.value);
    const period = (route.query.period as string) || undefined;
    return period ? convertPeriodFromRouteQueryToPeriod(period) : undefined;
  });

  function setPeriodToUrl(value: DateRange) {
    routerMutex.runExclusive(async () => {
      await router.replace({ query: { ...route.query, period: convertPeriodToRouteQueryFormat(value) } });
    });
  }

  const isValidPeriodFromUrl = computed(() => validatePeriod(periodFromUrl.value));

  return { periodFromUrl, setPeriodToUrl, isValidPeriodFromUrl };
}

function validatePeriod(period: DateRange | undefined) {
  if (!period) return false;
  const { start, end } = period;
  return isWithin2Years(start) && isOlderOrEqualTo2DaysAgo(end) && isIn30DaysRange(start, end);
}
